import { atomWithQuery } from "jotai-tanstack-query";
import { authAtom } from "../auth/atoms";
import { getAllSavedPlaces } from "../../apis";
import { Storage } from "../../storage";

export const userSavedPlacesAtom = atomWithQuery((get) => ({
  queryKey: ["getAllSavedPlaces"],
  queryFn: async () => {
    const savedPlaces = await getAllSavedPlaces(
      Storage.getCurrentUserToken() || ""
    );
    return savedPlaces;
  },
  enabled: false,
}));
